import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { MessageResponse, MessagesResponse, PostMessageParams } from "./types";

import { route } from "../../utils";

export * from "./types";

const ENDPOINTS = {
  LIST_MESSAGES:
    "/api/v2/org/:organization_id/user/:user_id/flow-sessions/:flow_session_id/messages",
  GET_MESSAGE:
    "/api/v2/org/:organization_id/user/:user_id/flow-sessions/:flow_session_id/messages/:flow_message_id",
  CREATE_MESSAGE:
    "/api/v2/org/:organization_id/user/:user_id/flow-sessions/:flow_session_id/messages",
};

export class FlowMessagesAPI {
  constructor(private client: CohesiveAPIClient) {}

  async list(
    flowSessionId: string,
    options?: { before_ts?: string },
    config?: AxiosRequestConfig,
  ): Promise<MessagesResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();
    const params = options?.before_ts ? { before_ts: options.before_ts } : {};

    const response = await this.client.axios.get<MessagesResponse>(
      route(ENDPOINTS.LIST_MESSAGES, {
        organization_id: organizationId,
        user_id: userId,
        flow_session_id: flowSessionId,
      }),
      {
        ...config,
        params: { ...config?.params, ...params },
      },
    );
    return response.data;
  }

  async get(
    flowSessionId: string,
    messageId: string,
    config?: AxiosRequestConfig,
  ): Promise<MessageResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.get<MessageResponse>(
      route(ENDPOINTS.GET_MESSAGE, {
        organization_id: organizationId,
        user_id: userId,
        flow_session_id: flowSessionId,
        flow_message_id: messageId,
      }),
      config,
    );
    return response.data;
  }

  async create(
    flowSessionId: string,
    data: PostMessageParams,
    config?: AxiosRequestConfig,
  ): Promise<MessageResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();
    const response = await this.client.axios.post<
      MessageResponse,
      any,
      PostMessageParams
    >(
      route(ENDPOINTS.CREATE_MESSAGE, {
        organization_id: organizationId,
        user_id: userId,
        flow_session_id: flowSessionId,
      }),
      data,
      config,
    );
    return response.data;
  }
}
